/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "LocalAssetsImportPageService";
const log: any = LoggerModule.getInstance();

export class LocalAssetsImportPageService {
  private static instance: LocalAssetsImportPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): LocalAssetsImportPageService {
    if (!LocalAssetsImportPageService.instance) {
      LocalAssetsImportPageService.instance =
        new LocalAssetsImportPageService(props);
    }
    return LocalAssetsImportPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async createGroup(group: any) {
    console.log(`inside create group`, group);
    const agent = getAgent();
    return agent.createGroup(group);
  }
}
